import { navigateTo, useRoute, useRouteParams } from '#imports'
import type { Ref } from 'vue'

import type {
  BasePageContent,
  ParentPageInfos,
} from '@backmarket/http-api/src/api-specs-content'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { objectKeys } from '@backmarket/utils/object/objectKeys'

import { PAGE_TYPE_WITH_NO_PARAMS_CORRECTION } from '../service/content-service.config'

function shouldCheckRouteParams(
  data: BasePageContent,
): data is BasePageContent & { parentPageInfos: ParentPageInfos } {
  const shouldIgnoreRouteParams =
    isEmpty(data.parentPageInfos) ||
    PAGE_TYPE_WITH_NO_PARAMS_CORRECTION.includes(data.pageType)

  return !shouldIgnoreRouteParams
}

export function useHandleIncorrectRouteParams(
  data: Ref<BasePageContent | null>,
) {
  if (!data.value) return

  if (!shouldCheckRouteParams(data.value)) return

  const { parentPageInfos } = data.value

  const currentRouteParams = useRouteParams()

  const parentPageParamKeys = objectKeys(parentPageInfos)
  const currentRouteParamKeys = Object.keys(currentRouteParams)

  const correctedPageParams = parentPageParamKeys.reduce((acc, key) => {
    if (
      currentRouteParamKeys.includes(key) &&
      currentRouteParams[key] !== parentPageInfos[key]
    ) {
      return {
        ...acc,
        [key]: parentPageInfos[key],
      }
    }

    return acc
  }, {})

  if (isEmpty(correctedPageParams)) {
    return
  }

  void navigateTo(
    {
      ...useRoute(),
      params: {
        ...currentRouteParams,
        ...correctedPageParams,
      },
    },
    { redirectCode: 301 },
  )
}
